<div class="table-responsive">
	<table class="table table-striped">
		<thead class="table-light">
			<th scope="col">Set</th>
			<th scope="col">Module</th>
			<th scope="col">Type</th>
			<th scope="col">Last change</th>
			<th scope="col">Changed By</th>
		</thead>
		<tbody>
			<tr *ngFor="let module of modules">
				<td class="form-check form-switch">
					<input
						class="form-check-input"
						type="checkbox"
						role="switch"
						id="SwitchCheck2"
						(click)="setModulesToUser(module, 1)"
						*ngIf="module.is_active == 0"
					/>
					<input
						class="form-check-input"
						type="checkbox"
						role="switch"
						id="SwitchCheck2"
						checked
						(click)="setModulesToUser(module, 0)"
						*ngIf="module.is_active == 1"
					/>
				</td>
				<td>
					{{ module.name }}
				</td>
				<td>{{ module.type }}</td>
				<td align="center">
					{{ module.last_change | utcToLocal : "medium" }}
				</td>
				<td align="center">{{ module.changed_by }}</td>
			</tr>
		</tbody>
	</table>
</div>
